// The `info-btn` that carries `shortlist-tooltip-*` attributes in the reports templates.
//
// ⚠️ THE ICON IS THE PIXEL SURFACE; THE TOOLTIP IS NOT. Every reference photographs this
// closed, so the diff only ever sees `<i class="cursor-pointer info-btn fa fa-info-circle">`
// — and `.info-btn` is coloured by the report cascade (#87DFFF) and sized by the table's own
// rule. The panel below is behaviour, not pixels, which is why it is a plain `title` rather
// than a port of upstream's positioned popover: getting the icon's classes wrong is a
// measurable regression, and getting the popover's placement wrong is not measurable at all.
//
// `placement` is accepted and recorded so the call sites keep saying what upstream says
// ('top', 'top-left', 'top-right'); when the popover is built it will need them.
import type { ReactElement } from 'react'

export type TooltipPlacement = 'top' | 'top-left' | 'top-right'

export interface InfoTooltipProps {
  title: string
  /** Plain text, or the lines of upstream's `…-content-html` block in order. */
  content: string | readonly string[]
  placement?: TooltipPlacement
}

export function InfoTooltip({ title, content, placement = 'top' }: InfoTooltipProps): ReactElement {
  const body = typeof content === 'string' ? content : content.join('\n')
  return (
    <i
      className="cursor-pointer info-btn fa fa-info-circle"
      title={`${title}\n${body}`}
      data-tooltip-placement={placement}
    />
  )
}
